export default __webpack_public_path__ + "static/media/darkSmileLogo.a4f4c898.svg";